<template>
  <div class="content">
    <div class="container-fluid">

      <!-- Detail Modal -->
      <div class="row">
        <b-modal id="modal-top-Details" hide-footer size="xl">
          <template #modal-header="{ close }">
            <h5>Contract Detail</h5>
            <p class="h5 mb-2">
              <b-icon icon="x-square" class="close-icon" @click="close()"></b-icon>
            </p>
          </template>
          <template v-if="selectedContract">
            <b-row class="mb-2">
              <b-col md="12" class="d-flex justify-content-end">
                <b-badge v-if="selectedContract.contractStatus == 1" variant="success" style="font-size:15px;">Active</b-badge>
                <b-badge v-else variant="danger" style="font-size:15px;">Terminated</b-badge>
              </b-col>
            </b-row>

            <!-- Tenant + House -->
            <b-row>
              <b-col md="6">
                <b-table-simple small bordered striped responsive hover>
                  <b-thead>
                    <b-tr><b-th colspan="2" class="text-center">Tenant Information</b-th></b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr><b-td style="width:40%;font-weight:600;">Full Name</b-td><b-td>{{ selectedContract.tenant ? selectedContract.tenant.fullName : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Phone</b-td><b-td>{{ selectedContract.tenant ? selectedContract.tenant.phoneNumber : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Email</b-td><b-td>{{ selectedContract.tenant ? (selectedContract.tenant.email || 'N/A') : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Sex</b-td><b-td>{{ selectedContract.tenant ? (selectedContract.tenant.sex || 'N/A') : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Address</b-td><b-td>{{ selectedContract.tenant ? selectedContract.tenant.address : 'N/A' }}</b-td></b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
                <b-table-simple small bordered striped responsive hover>
                  <b-thead>
                    <b-tr><b-th colspan="2" class="text-center">House Information</b-th></b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr><b-td style="width:40%;font-weight:600;">Building</b-td><b-td>{{ selectedContract.house ? selectedContract.house.buildingName : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Floor</b-td><b-td>{{ selectedContract.house ? selectedContract.house.floor : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Room Number</b-td><b-td>{{ selectedContract.house ? selectedContract.house.roomNumber : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Size</b-td><b-td>{{ selectedContract.house ? selectedContract.house.size : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Price Option</b-td><b-td>{{ selectedContract.house ? selectedContract.house.priceOption : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Currency</b-td><b-td>{{ selectedContract.house ? selectedContract.house.rentCurrencyType : 'N/A' }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Status</b-td><b-td>{{ selectedContract.house ? getHouseStatus(selectedContract.house.status) : 'N/A' }}</b-td></b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>

            <!-- Contract Info -->
            <b-row>
              <b-col md="12">
                <b-table-simple small bordered striped responsive hover>
                  <b-thead>
                    <b-tr><b-th colspan="2" class="text-center">Contract Information</b-th></b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr><b-td style="width:25%;font-weight:600;">Contract ID</b-td><b-td>{{ selectedContract.contractIdentifier }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Start Date</b-td><b-td>{{ selectedContract.startDate }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">End Date</b-td><b-td>{{ selectedContract.endDate }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Next Payment Date</b-td><b-td>{{ selectedContract.nextPaymentDate }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Due Date</b-td><b-td>{{ selectedContract.dueDate }} Days</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Period</b-td><b-td>{{ getPeriod(selectedContract.period) }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Payment Rule</b-td><b-td>{{ getPaymentCondition(selectedContract.paymentRule) }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Payment Status</b-td><b-td>
                      <b-badge v-if="selectedContract.paymentStatus === 'Paid'" style="color:rgba(240,206,13,0.937);background-color:rgb(37,91,48);">Paid</b-badge>
                      <b-badge v-else-if="selectedContract.paymentStatus === 'Unpaid'" variant="primary">Unpaid</b-badge>
                      <b-badge v-else-if="selectedContract.paymentStatus === 'Overdue'" variant="danger">Overdue</b-badge>
                      <span v-else>{{ selectedContract.paymentStatus }}</span>
                    </b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Initial Payment</b-td><b-td>{{ numberWithCommas(selectedContract.initialPayment) }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Paid Amount</b-td><b-td>{{ numberWithCommas(selectedContract.payedAmount) }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Registered By</b-td><b-td>{{ selectedContract.registeredBy }}</b-td></b-tr>
                    <b-tr><b-td style="font-weight:600;">Created Date</b-td><b-td>{{ selectedContract.createdDate }}</b-td></b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </template>
        </b-modal>
      </div>

      <!-- Main List -->
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <b-row class="mb-2">
                <b-col lg="2">
                  <label class="small mb-1">Owner</label>
                  <b-form-select v-model="filters.userId" :options="ownerUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Contract Status</label>
                  <b-form-select v-model="filters.contractStatus" :options="contractStatusOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Payment Status</label>
                  <b-form-select v-model="filters.paymentStatus" :options="paymentStatusOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Contract ID</label>
                  <b-form-input v-model="filters.contractIdentifier" size="sm" placeholder="Contract ID..."></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Tenant Name</label>
                  <b-form-input v-model="filters.tenantFullName" size="sm" placeholder="Tenant name..."></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Tenant Phone</label>
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>+251</b-input-group-prepend>
                    <b-form-input
                      v-model="filters.tenantPhoneNumber"
                      size="sm"
                      placeholder="9xxxxxxxx"
                      maxlength="9"
                      @keypress="onlyDigits"
                      :state="filters.tenantPhoneNumber ? phoneValid : null"
                    ></b-form-input>
                  </b-input-group>
                  <small v-if="filters.tenantPhoneNumber && !phoneValid" class="text-danger">Must start with 9 or 7, 9 digits</small>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col lg="2">
                  <label class="small mb-1">Building</label>
                  <b-form-select v-model="filters.buildingId" :options="buildingOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Room Number</label>
                  <b-form-input v-model="filters.houseRoomNumber" size="sm" placeholder="Room..."></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Created Date</label>
                  <b-form-input v-model="filters.contractCreatedDate" type="date" size="sm"></b-form-input>
                </b-col>
                <b-col lg="1" class="d-flex align-items-end">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">Reset</b-button>
                </b-col>
                <b-col lg="2" class="d-flex align-items-end">
                  <b-button size="sm" variant="success" class="mr-1" @click="exportExcel"><b-icon icon="file-earmark-excel"></b-icon> Excel</b-button>
                  <b-button size="sm" variant="danger" @click="exportPDF"><b-icon icon="file-earmark-pdf"></b-icon> PDF</b-button>
                </b-col>
                <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>

            <div class="table-container">
            <b-table-simple :small="true" sticky-header style="max-height: 395px;" striped responsive hover>
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Contract ID</b-th>
                  <b-th>Tenant</b-th>
                  <b-th>Phone</b-th>
                  <b-th>Building</b-th>
                  <b-th>House</b-th>
                  <b-th>Start Date</b-th>
                  <b-th>End Date</b-th>
                  <b-th>Next Payment</b-th>
                  <b-th>Payment Status</b-th>
                  <b-th>Contract Status</b-th>
                  <b-th>Due Date</b-th>
                  <b-th>Registered By</b-th>
                  <b-th sticky-column></b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody>
                  <b-tr>
                    <b-td colspan="14" class="text-center" style="display:table-cell;">
                      <b-spinner style="height:3rem;width:3rem;" variant="warning"></b-spinner>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
              <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                    <b-tr><b-td colspan="14" class="text-center">Nothing found</b-td></b-tr>
                  </template>
                  <template v-else>
                    <b-tr v-for="(item, index) in filterTable" :key="item.contractId || index">
                      <b-td>{{ (currentPage - 1) * perPage + index + 1 }}</b-td>
                      <b-td>{{ item.contractIdentifier }}</b-td>
                      <b-td>{{ item.tenant ? item.tenant.fullName : 'N/A' }}</b-td>
                      <b-td>{{ item.tenant ? item.tenant.phoneNumber : 'N/A' }}</b-td>
                      <b-td>{{ item.house && item.house.buildingName ? item.house.buildingName : 'N/A' }}</b-td>
                      <b-td>{{ item.house ? (item.house.floor + ' - ' + item.house.roomNumber) : 'N/A' }}</b-td>
                      <b-td>{{ item.startDate }}</b-td>
                      <b-td>{{ item.endDate }}</b-td>
                      <b-td>{{ item.nextPaymentDate }}</b-td>
                      <b-td>
                        <b-badge v-if="item.paymentStatus === 'Paid'" style="color:rgba(240,206,13,0.937);background-color:rgb(37,91,48);">Paid</b-badge>
                        <b-badge v-else-if="item.paymentStatus === 'Unpaid'" variant="primary">Unpaid</b-badge>
                        <b-badge v-else-if="item.paymentStatus === 'Overdue'" variant="danger">Overdue</b-badge>
                        <b-badge v-else-if="item.paymentStatus === 'contract disable'" variant="dark">Contract Disabled</b-badge>
                        <span v-else>{{ item.paymentStatus }}</span>
                      </b-td>
                      <b-td>
                        <b-badge v-if="item.contractStatus == 1" variant="success">Active</b-badge>
                        <b-badge v-else variant="danger">Terminated</b-badge>
                      </b-td>
                      <b-td>{{ item.dueDate }} days</b-td>
                      <b-td>{{ item.registeredBy }}</b-td>
                      <b-td sticky-column>
                        <b-badge @click="viewDetail(item)" variant="primary" style="cursor:pointer;">Detail</b-badge>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                <b-col md="3">
                  <b-form-group id="fieldset-horizontal" label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page" label-for="input-horizontal" label-align-xl="right">
                    <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="displayRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import * as XLSX from 'xlsx'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    components: { LTable, Card },
    data() {
      return {
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          { value: 7, text: 7 }, { value: 10, text: 10 },
          { value: 25, text: 25 }, { value: 50, text: 50 }, { value: 100, text: 100 }
        ],
        items: [],
        allItems: [],
        filter: '',
        searchSpinner: false,
        spinner: true,
        selectedContract: null,
        filters: {
          userId: null,
          contractStatus: null,
          paymentStatus: null,
          buildingId: null,
          contractIdentifier: '',
          tenantFullName: '',
          tenantPhoneNumber: '',
          houseRoomNumber: '',
          contractCreatedDate: ''
        },
        ownerUserOptions: [{ value: null, text: 'All Owners' }],
        buildingOptions: [{ value: null, text: 'All Buildings' }],
        contractStatusOptions: [
          { value: null, text: 'All Statuses' },
          { value: 1, text: 'Active' },
          { value: 0, text: 'Terminated' }
        ],
        paymentStatusOptions: [
          { value: null, text: 'All' },
          { value: 'Paid', text: 'Paid' },
          { value: 'Unpaid', text: 'Unpaid' },
          { value: 'OverDue', text: 'Overdue' }
        ]
      }
    },
    watch: {
      'filters.userId'() { this.applyFilters(); },
      'filters.contractStatus'() { this.applyFilters(); },
      'filters.paymentStatus'() { this.applyFilters(); },
      'filters.contractIdentifier'() { this.applyFilters(); },
      'filters.tenantFullName'() { this.applyFilters(); },
      'filters.tenantPhoneNumber'() {
        if (!this.filters.tenantPhoneNumber || this.phoneValid) this.applyFilters();
      },
      'filters.buildingId'() { this.applyFilters(); },
      'filters.houseRoomNumber'() { this.applyFilters(); },
      'filters.contractCreatedDate'() { this.applyFilters(); },
      filter(val) {
        if (val && val.trim()) {
          this.fetchAllForSearch();
        } else {
          this.allItems = [];
        }
      }
    },
    computed: {
      searchSource() {
        return this.filter && this.allItems.length ? this.allItems : this.items;
      },
      filterTable() {
        if (!this.filter) return this.items;
        const s = this.filter.trim().toLowerCase();
        return this.searchSource.filter(item => [
          item.contractIdentifier,
          item.tenant ? item.tenant.fullName : '',
          item.tenant ? item.tenant.phoneNumber : '',
          item.house ? item.house.buildingName : '',
          item.house ? item.house.floor : '',
          item.house ? item.house.roomNumber : '',
          item.startDate, item.endDate, item.nextPaymentDate,
          item.paymentStatus, item.contractStatus,
          item.dueDate, item.registeredBy
        ].some(v => v !== null && v !== undefined && String(v).toLowerCase().includes(s)));
      },
      displayRows() {
        return this.filter ? this.filterTable.length : this.totalRows;
      },
      phoneValid() {
        return /^[79]\d{8}$/.test(this.filters.tenantPhoneNumber);
      }
    },
    mounted() {
      this.getOwnerUsers();
      this.getBuildings();
      this.getAllContractsList();
    },
    methods: {
      onlyDigits(e) {
        if (!/\d/.test(e.key)) e.preventDefault();
      },
      fetchAllForSearch() {
        if (!this.totalRows) return;
        this.searchSpinner = true;
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllContractsList', payload)
          .then(response => { this.allItems = response.data.Contents || []; })
          .catch(error => { console.log('Error fetching all for search:', error); })
          .finally(() => { this.searchSpinner = false; });
      },
      buildPayload(page) {
        const payload = { page: page || this.currentPage, line: this.perPage };
        if (this.filters.userId !== null) payload.userId = this.filters.userId;
        if (this.filters.contractStatus !== null && this.filters.contractStatus !== undefined) payload.contractStatus = this.filters.contractStatus;
        if (this.filters.paymentStatus) payload.paymentStatus = this.filters.paymentStatus;
        if (this.filters.contractIdentifier) payload.contractIdentifier = this.filters.contractIdentifier;
        if (this.filters.tenantFullName) payload.tenantFullName = this.filters.tenantFullName;
        if (this.filters.tenantPhoneNumber && this.phoneValid) payload.tenantPhoneNumber = '+251' + this.filters.tenantPhoneNumber;
        if (this.filters.buildingId) payload.buildingId = this.filters.buildingId;
        if (this.filters.houseRoomNumber) payload.houseRoomNumber = this.filters.houseRoomNumber;
        if (this.filters.contractCreatedDate) payload.contractCreatedDate = this.filters.contractCreatedDate;
        return payload;
      },
      getAllContractsList() {
        this.spinner = true;
        this.allItems = [];
        this.$store.dispatch('getAllContractsList', this.buildPayload())
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
            if (this.filter && this.filter.trim()) this.fetchAllForSearch();
          })
          .catch(error => { console.log('Error fetching contracts:', error); })
          .finally(() => { this.spinner = false; });
      },
      applyFilters() {
        this.currentPage = 1;
        this.getAllContractsList();
      },
      resetFilters() {
        this.filters.userId = null;
        this.filters.contractStatus = null;
        this.filters.paymentStatus = null;
        this.filters.contractIdentifier = '';
        this.filters.tenantFullName = '';
        this.filters.tenantPhoneNumber = '';
        this.filters.buildingId = null;
        this.filters.houseRoomNumber = '';
        this.filters.contractCreatedDate = '';
        this.filter = '';
        this.allItems = [];
        this.currentPage = 1;
        this.getAllContractsList();
      },
      changePage(event, page) {
        this.currentPage = page;
        this.spinner = true;
        this.$store.dispatch('getAllContractsList', this.buildPayload(page))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching contracts:', error); })
          .finally(() => { this.spinner = false; });
      },
      changePerPage() {
        this.currentPage = 1;
        this.getAllContractsList();
      },
      getBuildings() {
        this.$store.dispatch('getAllBuildingsList', {})
          .then(response => {
            Array.from(response.data).forEach(b => {
              this.buildingOptions.push({ value: b.buildingId, text: b.buildingName });
            });
          })
          .catch(error => { console.log(error); });
      },
      getOwnerUsers() {
        this.$store.dispatch('getAllOwnerUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.ownerUserOptions.push({ value: user.id, text: user.fullName + ' (' + user.username + ')' });
            });
          })
          .catch(error => { console.log(error); });
      },
      fetchAllAndExport(format) {
        if (!this.totalRows) {
          this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
          return;
        }
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllContractsList', payload)
          .then(response => {
            const all = response.data.Contents || [];
            if (!all.length) {
              this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
              return;
            }
            if (format === 'excel') this.doExportExcel(all);
            else this.doExportPDF(all);
          })
          .catch(error => { console.log('Export error:', error); });
      },

      exportExcel() { this.fetchAllAndExport('excel'); },
      exportPDF()   { this.fetchAllAndExport('pdf'); },

      doExportExcel(all) {
        const data = all.map((item, i) => ({
          'No.': i + 1,
          'Contract ID': item.contractIdentifier,
          'Tenant': item.tenant ? item.tenant.fullName : 'N/A',
          'Phone': item.tenant ? item.tenant.phoneNumber : 'N/A',
          'Building': item.house ? item.house.buildingName : 'N/A',
          'House': item.house ? (item.house.floor + ' - ' + item.house.roomNumber) : 'N/A',
          'Start Date': item.startDate,
          'End Date': item.endDate,
          'Next Payment': item.nextPaymentDate,
          'Payment Status': item.paymentStatus,
          'Contract Status': item.contractStatus == 1 ? 'Active' : 'Terminated',
          'Due Date': item.dueDate,
          'Registered By': item.registeredBy
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Contracts');
        XLSX.writeFile(wb, 'Contracts.xlsx');
      },

      doExportPDF(all) {
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.text('Contracts List', 14, 14);
        const rows = all.map((item, i) => [
          i + 1,
          item.contractIdentifier,
          item.tenant ? item.tenant.fullName : 'N/A',
          item.tenant ? item.tenant.phoneNumber : 'N/A',
          item.house ? item.house.buildingName : 'N/A',
          item.house ? (item.house.floor + ' - ' + item.house.roomNumber) : 'N/A',
          item.startDate,
          item.endDate,
          item.nextPaymentDate,
          item.paymentStatus,
          item.contractStatus == 1 ? 'Active' : 'Terminated',
          item.dueDate,
          item.registeredBy
        ]);
        doc.autoTable({
          head: [['No.','Contract ID','Tenant','Phone','Building','House','Start Date','End Date','Next Payment','Payment Status','Contract Status','Due Date','Registered By']],
          body: rows,
          startY: 20
        });
        doc.save('Contracts.pdf');
      },

      viewDetail(item) {
        this.selectedContract = item;
        this.$bvModal.show('modal-top-Details');
      },
      getPeriod(period) {
        if (!period) return 'N/A';
        return 'Every ' + period + ' month(s)';
      },
      getPaymentCondition(condition) {
        if (!condition) return 'N/A';
        switch (condition.toLowerCase()) {
          case 'above': return 'Advance Payment Permitted';
          case 'below': return 'Partial Payment Permitted';
          case 'yesboth': return 'Both Advance and Partial Payment Permitted';
          default: return 'Neither Advance Nor Partial Payment Permitted';
        }
      },
      getHouseStatus(status) {
        return status == 1 ? 'Rented' : 'Free';
      },
      numberWithCommas(x) {
        if (x !== null && x !== undefined && x !== '') {
          const num = parseFloat(x);
          if (!isNaN(num)) return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return '0.00';
      }
    }
  }
</script>

<style scoped>
.table-container {
  overflow: auto;
}
.pagination-container {
  position: relative;
  z-index: 1;
  background: #fff;
}
.text-warning {
  color: rgba(240, 206, 13, 0.937) !important;
}
</style>
